export default __webpack_public_path__ + "static/media/Web.b715f1b4.png";